import {
  ControlledSelect,
  ControlledCheckbox
} from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import {
  masterDataApplicationOptions,
  workforceManagementApplicationOptions
} from '../utils';
import { isSDBAccount } from 'utils/misc';
import { Box, InputAdornment } from '@mui/material';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        '& section': { pt: 0.5 },
        '& .MuiBox-root': { maxWidth: '100%', textWrap: 'balance' }
      }}
    >
      <MultiStepForm.Section
        title={t('negativeAvailabilitySettings.activityPlanning')}
      >
        <ControlledNumericField
          name="neg_hours_base"
          label={t('negativeAvailabilitySettings.neg_hours_base')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('negativeAvailabilitySettings.hours')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="neg_hours_factor"
          label={t('negativeAvailabilitySettings.neg_hours_factor')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('negativeAvailabilitySettings.percent')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="neg_hours_min_time_block"
          label={t('negativeAvailabilitySettings.neg_hours_min_time_block')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('negativeAvailabilitySettings.hours')}
              </InputAdornment>
            )
          }}
        />
      </MultiStepForm.Section>

      {isSDBAccount() && (
        <MultiStepForm.Section title={t('activityPlanningSettings.title')}>
          <ControlledSelect
            control={control}
            label={t(
              'activityPlanningSettings.activity_planning_masterdata_application'
            )}
            name="activity_planning_masterdata_application"
            options={masterDataApplicationOptions}
          />

          <ControlledSelect
            control={control}
            label={t(
              'activityPlanningSettings.activity_planning_workforcemanagement_application'
            )}
            name="activity_planning_workforcemanagement_application"
            options={workforceManagementApplicationOptions}
          />
        </MultiStepForm.Section>
      )}

      <MultiStepForm.Section
        title={t('activityPlanningSettings.activitySuggestions')}
      >
        <ControlledCheckbox
          control={control}
          name="activity_planning_activity_suggestions_enableActivityGlobalSearch"
          label={t(
            'activityPlanningSettings.activity_planning_activity_suggestions_enableActivityGlobalSearch'
          )}
        />

        <ControlledCheckbox
          control={control}
          name="activity_planning_activity_suggestions_showActivitiesWithoutRequirementAsSuggestion"
          label={t(
            'activityPlanningSettings.activity_planning_activity_suggestions_showActivitiesWithoutRequirementAsSuggestion'
          )}
        />
      </MultiStepForm.Section>
    </Box>
  );
};

export default FormContent;
